import { useTranslation } from 'react-i18next';

interface EmptyJobCardProps {
  onViewJobs: () => void;
}

export default function EmptyJobCard({ onViewJobs }: EmptyJobCardProps) {
  const { t } = useTranslation();
  
  return (
    <div className="bg-white rounded-2xl p-6 shadow-md text-center">
      <div className="w-16 h-16 flex items-center justify-center bg-blue-50 rounded-full mx-auto mb-4">
        <i className="ri-map-pin-line text-3xl" style={{ color: '#006491' }}></i>
      </div>
      
      <h3 className="text-base font-bold text-gray-900 mb-2">
        {t('noActiveDeliveries')}
      </h3>
      
      <p className="text-sm text-gray-600 mb-5">
        {t('youreReadyToAcceptNewJobs')}
      </p>
      
      <button
        onClick={onViewJobs}
        className="w-full px-5 py-3 rounded-full text-sm font-bold text-white transition-all"
        style={{ backgroundColor: '#006491' }}
      >
        {t('viewAvailableJobs')}
      </button>
    </div>
  );
}
